import { getOthHoofdstukReservering } from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';

export const useHoofdstukReservering = createQuery({
  key: ['hoofdstukReservering'],
  queryFn: getOthHoofdstukReservering,
});
